import { Component, OnInit } from '@angular/core';
import { HrmsService,MasterService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-workoffline',
  templateUrl: './workoffline.component.html',
  styleUrls: ['./workoffline.component.scss'],
  providers:[HrmsService,MasterService]
})
export class WorkofflineComponent implements OnInit {

   sections:any=[];
    arrstaff:any=[];
    classes:any=[];
    attcordata:any=[];
    arrsubjects:any=[];
    fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0',atscope:'Individual'};
    attdata:any=[];
    arrper:any=[];
    attcordetdata:any=[];
    arrcnmcls:any=[];
    arrcourse:any=[];
    arrworklist:any=[];
    attcondata:any=[];
    oprtype:any='';
    tabledata: any = {};
    objclass:any={};
    arrstulst:any=[];
    fmodel1:any={};
    cmodel:any={};
    amodel:any={};
    objvhead:any={};
    arrcmbdet:any=[];
    msgexist="";
    corclasses:any=[];
    corsections:any=[];
    corsubjects:any=[];
    arrwktype:any=[];
    arrwkstatus:any=[];

    memberdetails:any[]=[];
        classdetails:any[]=[];
        arrashead:any=[];
        arrastype:any=[];
        closeResult: string;
      
        section: any=[];
       
        arrsubcomb:any=[];
        student:boolean=true;
        staff:boolean=false;
        memberdash:any={};
        objass:any={};
        objastype:any={};
        objfilt:any={};
        arreval:any=[];
        arrevpatern:any=[];
        arrcat:any=[];
        arract:any=[{name:'Yes'},{name:'No'}];
        arrledom:any=[{name:'Weekly'},{name:'Monthly'},{name:'Quarterly'},{name:'Half Yearly'},{name:'Yearly'}];
        objmethod:any={};
        objpo:any={};
        objlevel:any={};
        objco:any={};
        selstudent:any={};
        arflstudent: any;
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
    arratscope:any=[{name:'Individual'},{name:'Combined'}];
    arropt:any=[{name:'Yes'},{name:'No'}];
  
    dropdownList = [];
    selectedItems = [];
    colums:any=[];
    objsubalot:any={};
    completeDate: Date;
    localCompleteDate: string;
    
    constructor(private http: HttpClient, private sservice: HrmsService,private mservice:MasterService,private modalService: NgbModal) { 
  
      this.completeDate = new Date();
      this.localCompleteDate = this.completeDate.toISOString();
      this.localCompleteDate = this.localCompleteDate.substring(0, 16).replace("T"," ");
        this.cmodel.frdt=this.mservice.getdatetoday();
  this.cmodel.todt=this.mservice.getdatetoday();
    }
    
    ngOnInit(): void {
      
      this.corsubject();

     
    }
  
    addstudents()
    {
  
      console.log(this.selectedItems);
    }
  
  
   
  
    printcertificate(){
  debugger
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');

   var url=this.mservice.callurl+"/fpdf181/pdfreports/staffactivity.php?clcd="+clcd+"&aycd="+aycd+"&emid="+this.cmodel.emid+"&frdt="+this.cmodel.frdt+"&todt="+this.cmodel.todt;

   window.open(url,'');
  
 }
  
    
  
  
   
      corsubject() {
        this.mservice.staffrolewise()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                //resultArray.unshift({emid:"0",emnm:"ALL"});
             //  resultArray.shift();
                this.corsubjects = resultArray;
               
                this.cmodel.emid=resultArray[0].emid;
                this.amodel.emid=resultArray[0].emid;
                this.SelectAttdcorDetails();
            },
            error => console.log("Error :: " + error)
            )
      }
  
  
      
  
  
  
  
  
 
  
 
  
  
  exportconrpt()
  {
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.mservice.callurl+"export/expworkconatt.php?clcd="+clcd+"&aycd="+aycd+"&frdt="+this.amodel.frdt+"&todt="+this.amodel.todt+"&clid="+this.amodel.clid+"&scid="+this.amodel.scid+"&crid="+this.amodel.crid+"&emid="+this.amodel.emid;
     console.log("url",url)
     window.open(url,'');
  
  }
  
 
      
      SelectAttdcorDetails() {
        debugger
  
        // console.log('pstdat1',this.cmodel);
        this.cmodel.clid=0;
        this.cmodel.crid=0;
        this.cmodel.scid=0;
  
        this.sservice.selhrmworkdairy(this.cmodel,'seloff')
        .subscribe(resultArray => {
            console.log('ret-by-atd', resultArray);
            this.attcordata = resultArray;
  
            //alert(resultArray.message);
  
        }, error =>
            alert('error in connection')
        );
      }
  
  
      
  
      exportcolrpt()
      {
        var clcd=localStorage.getItem('clcd');
        var aycd=localStorage.getItem('aycd');
         var url=this.mservice.callurl+"export/expworkdairy.php?clcd="+clcd+"&aycd="+aycd+"&frdt="+this.cmodel.frdt+"&todt="+this.cmodel.todt+"&emid="+this.cmodel.emid1;
            console.log("url",url);
         window.open(url,'');
      
      }  
     
   
  SaveDetails() {
  
   // var clssubdata = {astmfm:from,astmto:to, clid: clid, suid: subid, oprtag: this.objsch.oprtype,asid:assid,astpid:asstypeid,portion:portion,rmk:remarks,asdt:assdt,clcd:clcd,aycd:aycd,baid:baid };
    
    this.objsubalot.suid=0;
    this.objsubalot.crid=0;
    this.objsubalot.clid=0;
    this.objsubalot.scid=0;
    // this.objsubalot.emid=0;
    // this.objsubalot.wkstdt=this.localCompleteDate;
    // this.objsubalot.wkendt=this.localCompleteDate;
    this.objsubalot.wkcpdt='';
    this.objsubalot.wkstatus='2';
    this.objsubalot.wktype='2';
    // this.objsubalot.wkdisc="";
    this.objsubalot.rmk="";
    // this.objsubalot.oprtype='insert';

   
    console.log('save-model', this.objsubalot);
    this.sservice.savehrmworkdairy( this.objsubalot)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            if(resultArray.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
             // this.Getsel_sp_massubgp();
             this.SelectAttdcorDetails();
            }
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();
  }
  
     deloffactivity(objdata)
  {
   if(confirm("Are you sure to delete this record?"))
    {
    this.objsubalot=objdata;
    this.objsubalot.oprtype='delete';
    this.sservice.savehrmworkdairy( this.objsubalot)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            this.SelectAttdcorDetails();
            
  })
}
}
  
      openentry(content,objdata,cmd) {
        debugger
         
        // this.subjects(this.cmodel.clid,this.cmodel.crid);
          if(cmd=="insert")
          {
           // this.objsubalot={};
            this.objsubalot.rid=0;
            this.objsubalot.wkstdt=this.localCompleteDate;
            this.objsubalot.wkendt=this.localCompleteDate;
            // this.objsubalot.wkcpdt=this.localCompleteDate;
            // this.objsubalot.crid=this.cmodel.crid;
            // this.objsubalot.clid=this.cmodel.clid;
            // this.objsubalot.scid=this.cmodel.scid;
            this.objsubalot.emid=this.cmodel.emid;
            // this.objsubalot.suid=this.cmodel.suid;
            // this.objsubalot.wkstatus=this.arrwkstatus[0].gcd;
            // this.objsubalot.wktype=this.arrwktype[0].gcd;
            this.objsubalot.wkdisc="";
            this.objsubalot.rmk="";
            this.objsubalot.oprtype=cmd;
  
          }
          else if(cmd=="update")
          { this.objsubalot=objdata;
            this.objsubalot.oprtype=cmd;
            
          }
         // this.getattdetails();
          this.modalOptions = {
            backdrop:'static',
            backdropClass:'customBackdrop',
            size:'md'
           
          }
          this.modalRef=this.modalService.open(content,this.modalOptions);
          
          this.modalRef.result.then((result) => {
         
               
            }, (reason) => {
                
            });
        }
        
  
    masclass() {
      this.mservice.classmasterrolewise(0,this.objfilt.crid,0,'class')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.objfilt.clid=resultArray[0].clid;
              this.subjects(this.objfilt.clid,this.objfilt.crid);

              // this.fmodel1.clid=resultArray[0].clid;
              // this.cmodel.clid=resultArray[0].clid;
              // this.massection();
              // this.masperiod();
             // this.mascourse();
             
          },
          error => console.log("Error :: " + error)
          )
    }
       subjects(clid,crid) {
        this.mservice.subjectsrolewise(0,0,clid,'asaa',crid)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrsubjects = resultArray;
                // this.corsubjects = resultArray;
                this.objfilt.suid=resultArray[0].suid;
               // this.cmodel.suid=resultArray[0].suid;
                this.getobetlp();
            },
            error => console.log("Error :: " + error)
            )
      }
        private getcourses() {
      
          this.mservice.getcourse()
        .subscribe((result:any) => {
        
        this.arrcourse=result;
        this.objfilt.crid=result[0].crid;
        this.masclass();
        
        }, error => {
        
        //alert('error in r');
        // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
        }
        );
          
          
        }
      
        // Getsubcomb()
        // {
        //   debugger
        //   this.mservice.sel_sp_exmsubcomb()
        //   .subscribe(
            
        //    resultArray =>{
        //     console.log('result',resultArray) ;
        //     this.objfilt.sucbid=resultArray[0].sucbid;
        //     //this.clsdate=resultArray;
        //     this.arrsubcomb = resultArray;
        //     //this.getevpattern();
        //     },
        //    error => console.log("Error :: " + error)
        // )
        // }
         
      
      
        // massection() {
        //   this.mservice.massection()
        //       .subscribe(
        //       resultArray => {
        //           console.log('getdashcounts', resultArray);
        //           this.section = resultArray;
                 
        //       },
        //       error => console.log("Error :: " + error)
        //       )
        // }
    
           
    
        
    
        
  
         getobemtpmap(obj) {
          this.mservice.getobemtpmap(obj)
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.arreval = resultArray;
                 
              },
              error => console.log("Error :: " + error)
              )
        }

        onsubchange()
        {
          var pst={clid:this.objfilt.clid,crid:this.objfilt.crid,suid:this.objlevel.suid};
          this.getobemtpmap(pst);
        }

    
        getobetlp() {
      
          
          this.mservice.getobetlp(this.objfilt)
              .subscribe(
              resultArray => {
                  console.log('getdashcounts', resultArray);
                  this.arrastype=resultArray;
                 this.getobemtpmap(this.objfilt);
                 
              },
              error => console.log("Error :: " + error)
              )
        }
      
       
        
       
          onmemberselectEvent(item) {

    console.log('item',item);
    this.objlevel.duration=item.duration;
    this.objlevel.tpid=item.tpid;
   }
        onmemberChangeSearch(sertxt) {
    debugger
  

  

  this.arflstudent= this.arreval.filter(item => {
      
      const nameMatches = item.tpnm.toLowerCase().includes(sertxt.toLowerCase());
     
      return nameMatches ; 
    });
    console.log('arflstudent',this.arflstudent);
  }
 
       
    
        
       
        
      
     
    
    
    
    
    
       openlevels(content,objdata,cmd) {
          debugger
         
          
          if(cmd=='insert')
          {
            this.objlevel={};
           
            
            
            this.objlevel.lpid='0';
            this.objlevel.tpnm='';
            this.objlevel.duration=0;
            this.objlevel.pltype='Daily';
            
            this.objlevel.frdt=this.mservice.getdatetoday();
            this.objlevel.todt=this.mservice.getdatetoday();
             this.objlevel.active='Yes';
           
            this.objlevel.oprtype='insert';
            this.objlevel.clid=this.objfilt.clid;
            this.objlevel.crid=this.objfilt.crid;
            this.objlevel.suid=this.objfilt.suid;
           
          }
        
          else if(cmd=='update')
          {
            this.objlevel=objdata;
            // this.getobemtpmap(this.objfilt);
            this.objlevel.oprtype='update';
this.onmemberChangeSearch(objdata.tpnm);
          this.selstudent=  this.arflstudent[0];
          }
          
          this.modalOptions = {
            backdrop:'static',
            backdropClass:'customBackdrop',
            size:'lg'
           
          }
          this.modalRef=this.modalService.open(content,this.modalOptions);
          
          this.modalRef.result.then((result) => {
         
               
            }, (reason) => {
                
            });
        }
    
        delclassactivity(objdata)
        {
         if(confirm("Are you sure to delete this record?"))
          {
          this.objlevel=objdata;            
          this.objlevel.oprtype='delete';
          this.mservice.save_obetlp( this.objlevel)
              .subscribe(resultArray => {
                  console.log('ret-save', resultArray);
                 alert (resultArray.message);
                  this.getobetlp();
                })
              }
            }
    
        save_obemlevels()
      {
        // this.objlevel.tpid=this.selstudent.tpid;
        if(this.objlevel.tpid)
        {
      console.log('saveobj',this.objlevel);
        this.mservice.save_obetlp(this.objlevel)
            .subscribe(
            result => {
                console.log('SavegenmasDetails', result);
                //this.suppliers = resultArray;
                alert(result.message);
                if(result.status=='success')
                {
                  let localmodref=this.modalRef;
                  localmodref.close();
                //  this.masasstype();
               this.getobetlp();
                }
               else
               {
      
               }
            },
            error =>{ alert('Error While saving...');}
            )
          }

          else
          {
            alert('Please select topic');
          }
      }
  
  }
  
